import { render, staticRenderFns } from "./remove-release-authorization.component.vue?vue&type=template&id=f77dc8b0&"
import script from "./remove-release-authorization.component.vue?vue&type=script&lang=ts&"
export * from "./remove-release-authorization.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports